import React, { useEffect, useState } from 'react';
import { FlaskConical } from 'lucide-react';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

// Thin site-wide indicator shown while Demo Mode is ON.
export default function DemoBanner() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let active = true;
    fetch(`${API_BASE}/api/public/demo-mode`)
      .then((r) => r.json())
      .then((d) => { if (active) setEnabled(!!d.enabled); })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  if (!enabled) return null;

  return (
    <div className="fixed top-16 md:top-20 left-0 right-0 z-40 bg-amber-500 text-white text-xs md:text-sm py-1.5 px-4 flex items-center justify-center gap-2 shadow-sm" data-testid="demo-banner">
      <FlaskConical className="w-4 h-4 shrink-0" />
      <span>Demo data is active — sample doctors, hospitals &amp; treatments are shown for testing. Admins can hide this in production.</span>
    </div>
  );
}
